<template>
  <div>
   <div v-if="result">
    You got {{result.correct}} right out of {{result.total}} questions<p></p>
    <h3>Share Your Results</h3>
  
       <div class="row">
         <div class="col-sm-4"></div>
          <div class="col-sm-4">
              <b-button block squared @click="tweetShare()" size="lg" variant="success" >Twitter</b-button><p></p>
         
          </div>
         <div class="col-sm-4"></div>
  </div>
    </div>
   </div>  
</template>

<script>
export default {
  name: 'QuizResults',
  props: {
    result: Object,
    
  },
  data () {
      return {
title: 'Godfather of Harlem'
      }
  },
  methods: {
   // will grab the latest quizzes
   tweetShare() {
     window.open("https://www.twitter.com/intent/tweet?text="+this.title, 
                '_blank');
   }
  },
  create () {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn-success  {
  background-color: #1da1f2
}
.btn-success:hover {
  background-color: #1da1f2
}
</style>
